"use client";
import Hero from "@/app/home/[locale]/(landingnew)/Hero";
import Button from "@/components/Button";
import { ArrowRightIcon } from "lucide-react";
import Link from "next/link";
import { Trans } from "react-i18next";
import AllSubscription from "./AllSubscription";
import AsFeatured from "./AsFeatured";

export default function Landing() {
  return (
    <div className="mt-20 min-h-[80dvh]">
      <Hero />

      <section className="mx-auto mt-10 px-3 w-full max-w-[100rem]">
        <h1 className="mb-3 font-montserrat font-bold text-foreground/60 text-2xl lg:text-3xl text-center">
          <Trans i18nKey="landing:as_featured_in" />
        </h1>
        <AsFeatured />
      </section>

      <div className="mx-auto mt-10 lg:mt-20 mb-10 px-3 w-full max-w-[100rem]">
        <h1 className="font-montserrat font-bold text-2xl lg:text-5xl text-center">
          <Trans i18nKey="landing:home_feature_title">
            Emang bisa apa aja sih?
          </Trans>
        </h1>
      </div>

      <section className="mx-auto px-3 w-full max-w-[100rem]">
        <div className="flex flex-wrap -mx-3 mt-5">
          <div className="w-full lg:w-4/12">
            <div className="relative pb-[100%]">
              <div className="absolute inset-3 flex flex-col justify-end bg-[#FAF7F3] p-3 lg:p-6 border rounded-3xl overflow-hidden">
                <Link href="/shortener" className="z-40 absolute inset-0" />
                <div
                  className="flex-1 bg-contain bg-no-repeat bg-center w-full"
                  style={{
                    backgroundImage: "url(/images/landing-001.png)",
                  }}
                />
                <h3 className="font-worksans font-semibold text-lg lg:text-4xl">
                  <Trans i18nKey="landing:home_shortener_title">
                    Shortener
                  </Trans>
                </h3>
                <p className="mt-2 max-w-md font-worksans lg:text-xl">
                  <Trans i18nKey="landing:home_shortener_desc">
                    Buat campaign, postingan media sosial, atau apapun dengan
                    link yang mudah diingat dan pendek dari s.id
                  </Trans>
                </p>
              </div>
            </div>
          </div>
          <div className="p-3 lg:p-0 w-full lg:w-8/12">
            <div className="relative lg:pb-[50%]">
              <div className="lg:absolute inset-3 flex flex-col justify-end bg-[#F7F7F9] p-4 lg:p-6 border rounded-3xl overflow-hidden">
                <Link href="/microsite" className="z-40 absolute inset-0" />
                <div
                  className="top-0 right-0 bottom-0 lg:absolute bg-contain bg-no-repeat bg-center pb-[100%] lg:pb-0 w-full lg:w-6/12"
                  style={{
                    backgroundImage: "url(/images/landing-002.png)",
                  }}
                />
                <div>
                  <h3 className="font-worksans font-semibold text-lg lg:text-4xl">
                    <Trans i18nKey="landing:home_microsite_title">
                      Microsite
                    </Trans>
                  </h3>
                  <p className="mt-1 lg:mt-2 max-w-md font-worksans lg:text-xl">
                    <Trans i18nKey="landing:home_microsite_desc">
                      Buat, kustomisasi, dan ekspresikan kebutuhanmu, semua
                      dalam satu tempat dengan Microsite s.id tanpa perlu
                      coding.
                    </Trans>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="p-3 lg:p-0 w-full lg:w-8/12">
            <div className="relative lg:pb-[50%]">
              <div className="lg:absolute inset-3 flex flex-col justify-end bg-[#EBF6F5] p-4 lg:p-6 border rounded-3xl overflow-hidden">
                <Link href="/shop" className="z-40 absolute inset-0" />
                <div
                  className="top-0 right-0 bottom-0 lg:absolute bg-contain bg-no-repeat bg-center pb-[100%] lg:pb-0 w-full lg:w-6/12"
                  style={{
                    backgroundImage: "url(/images/landing-004.png)",
                  }}
                />
                <div>
                  <h3 className="font-worksans font-semibold text-lg lg:text-4xl">
                    <Trans i18nKey="landing:home_shop_title">Shop</Trans>
                  </h3>
                  <p className="mt-1 lg:mt-2 max-w-md font-worksans lg:text-xl">
                    <Trans i18nKey="landing:home_shop_desc">
                      Jual produk digitalmu dengan mudah dan jangkau lebih
                      banyak pelanggan dengan s.id Shop.
                    </Trans>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-4/12">
            <div className="relative pb-[100%]">
              <div className="absolute inset-3 flex flex-col justify-end bg-[#FBEDE6] p-4 lg:p-6 border rounded-3xl overflow-hidden">
                <Link href="/qr-code" className="z-40 absolute inset-0" />
                <div
                  className="flex-1 bg-contain bg-no-repeat bg-center w-full"
                  style={{
                    backgroundImage: "url(/images/landing-003.png)",
                  }}
                />
                {/* <img src="/images/landing-003.png" /> */}
                <h3 className="font-worksans font-semibold text-lg lg:text-4xl">
                  <Trans i18nKey="landing:home_qrcode_title">QR Code</Trans>
                </h3>
                <p className="mt-1 lg:mt-2 max-w-md font-worksans lg:text-xl">
                  <Trans i18nKey="landing:home_qrcode_desc">
                    Pantau campaign, gaya, dan kustomisasi QR Code-mu, semua
                    dalam satu tempat dengan s.id QR Code
                  </Trans>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto mt-20 lg:mt-32 px-3 w-full max-w-[100rem]">
        <h1 className="mx-auto max-w-6xl font-montserrat font-bold text-2xl lg:text-6xl text-center">
          <Trans i18nKey="landing:home_subscription_title">
            Maksimalkan Tools dengan Subscription s.id
          </Trans>
        </h1>
        <p className="mx-auto mt-4 max-w-4xl font-worksans lg:text-2xl text-center">
          <Trans i18nKey="landing:home_subscription_desc">
            Berlangganan subscription s.id dan dapatkan fitur-fitur menarik
            lainnya.
          </Trans>
        </p>

        <AllSubscription noAction />

        <div className="flex justify-center mt-8 w-full">
          <Link href="/subscription">
            <Button
              className="flex items-center px-4 h-auto font-montserrat font-medium text-xl"
              roundFull
            >
              <Trans i18nKey="landing:see_more_detailed">
                Lihat lebih lengkap
              </Trans>{" "}
              <ArrowRightIcon className="!size-6" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
